@for (item of items; track item; let i = $index) {
  <div class="cx-item-list-row cart-item-list__row">
    @if (getControl(item) | async; as control) {
      <div
        class="cx-item-list-items cart-item-list__items"
        [class.is-changed]="control.get('quantity').disabled"
        >
        <app-uig-cart-item
          [item]="item"
          [cartId]="cartId"
          [quantityControl]="control.get('quantity')"
          [readonly]="readonly"
          [promotionLocation]="promotionLocation"
          [options]="options"
          [savedCarts]="savedCarts"
          >
        </app-uig-cart-item>
      </div>
    }
  </div>
}

<ng-template #totalHeader>
  <div class="cx-item-list-total col-md-2">
    {{ 'uigCartItems.total' | cxTranslate }}
  </div>
</ng-template>
